import * as signalR from "@microsoft/signalr";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ControlConnectionRetryPolicy from "../../Policies/ControlConnectionRetryPolicy";
import AuthProvider from "../../services/AuthProvider";
function useSignalRConnection(url) {
    const [connection, setConnection] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        let signalUri = `${process.env.REACT_APP_API_URL}${url}`;
        if (url.indexOf("droneHub") !== -1 &&
            location.state &&
            location.state.token) {
            signalUri += `&adminToken=${location.state.token}`;
        }
        const token = AuthProvider.getAuthToken();
        if (!token) {
            //navigate("/login");
            return;
        }
        let conn = new signalR.HubConnectionBuilder()
            .configureLogging(signalR.LogLevel.Debug)
            .withAutomaticReconnect(new ControlConnectionRetryPolicy())
            .withKeepAliveInterval(300)
            .withServerTimeout(1500)
            .withUrl(signalUri, {
            skipNegotiation: true,
            transport: signalR.HttpTransportType.WebSockets,
            accessTokenFactory: () => token,
        })
            .build();
        conn
            .start()
            .then(() => {
            setConnection(conn);
            console.log("Info connection state: " + conn.state);
        })
            .catch(() => {
            console.log("Connection failed. Retrying in 1 second.");
        });
        return () => {
            conn.stop();
        };
    }, [url]);
    return connection;
}
export default useSignalRConnection;
